export const getEventEmitters = (subscribers) => {
    const onAllModelsLoaded = () => {
        subscribers.allModelsLoaded.forEach(callback => callback());
    };
    const onConflict = (conflicts) => {
        subscribers.conflict.forEach(callback => callback(conflicts));
    };
    const onDuplicate = (entity) => {
        subscribers.duplicate.forEach(callback => callback(entity));
    };
    const onDeselected = (productEntity) => {
        subscribers.deselected.forEach(callback => callback(productEntity));
    };
    const onEnableNightMode = (enabled) => {
        subscribers.enableNightMode.forEach(callback => callback(enabled));
    };
    const onHelpLinesConflictsResolved = () => {
        subscribers.helpLinesConflictsResolved.forEach(callback => callback());
    };
    const onHelpLinesShapeResizeFinished = () => {
        subscribers.helpLinesShapeResizeFinished.forEach(callback => callback());
    };
    const onHelpLinesShapeChange = () => {
        subscribers.helpLinesShapeChange.forEach(callback => callback());
    };
    const onHelpLinesShapeResize = () => {
        subscribers.helpLinesShapeResize.forEach(callback => callback());
    };
    const onHelpLinesUpdated = () => {
        subscribers.helpLinesUpdated.forEach(callback => callback());
    };
    const onHistory = () => {
        subscribers.history.forEach(callback => callback());
    };
    const onInScene = (entity) => {
        subscribers.inScene.forEach(callback => callback(entity));
    };
    const onInvalidPlacement = (entityIds) => {
        subscribers.invalidPlacement.forEach(callback => callback(entityIds));
    };
    const onLoad = () => {
        subscribers.load.forEach(callback => callback());
    };
    const onLoadDesignId = () => {
        subscribers.loadDesignId.forEach(callback => callback());
    };
    const onLoadLegacyShoppingItems = (legacyShoppingItems) => {
        subscribers.loadLegacyShoppingItems.forEach(callback => callback(legacyShoppingItems));
    };
    const onLoadVpc = () => {
        subscribers.loadVpc.forEach(callback => callback());
    };
    const onLoadVpcFailure = (vpcCode) => {
        subscribers.loadVpcFailure.forEach(callback => callback(vpcCode));
    };
    const onLoadVpcSuccess = () => {
        subscribers.loadVpcSuccess.forEach(callBack => callBack());
    };
    const onLoadWallShapeFromVpc = (event) => {
        subscribers.loadWallShapeFromVpc.forEach(callback => callback(event));
    };
    const onModelLoaded = (entityId) => {
        subscribers.modelLoaded.forEach(callback => callback(entityId));
    };
    const onMoveEnd = () => {
        subscribers.moveEnd.forEach(callback => callback());
    };
    const onMoving = () => {
        subscribers.moving.forEach(callback => callback());
    };
    const onPlacementAttempt = (errorMessages) => {
        subscribers.placementAttempt.forEach(callback => callback(errorMessages));
    };
    const onProppingAgeGroupUpdated = (proppingAgeGroup) => {
        subscribers.proppingAgeGroupUpdated.forEach(callback => callback(proppingAgeGroup));
    };
    const onRoomSize = (event) => {
        subscribers.roomSize.forEach(callback => callback(event));
    };
    const onRedo = () => {
        subscribers.redo.forEach(callback => callback());
    };
    const onReset = () => {
        subscribers.reset.forEach(callback => callback());
    };
    const onSaveDesignId = (designId) => {
        subscribers.saveDesignId.forEach(callback => callback(designId));
    };
    const onSaveVpcComplete = (configurationId) => {
        subscribers.saveVpcComplete.forEach(callback => callback(configurationId));
    };
    const onSaveVpcStart = () => {
        subscribers.saveVpcStart.forEach(callback => callback());
    };
    const onSelected = (productEntity) => {
        subscribers.selected.forEach(callback => callback(productEntity));
    };
    const onSolutionUpdateDone = () => {
        subscribers.solutionUpdateDone.forEach(callback => callback());
    };
    const onSolutionUpdateInProgress = () => {
        subscribers.solutionUpdateInProgress.forEach(callback => callback());
    };
    const onTooManyLightsAdded = () => {
        subscribers.tooManyLightsAdded.forEach(callback => callback());
    };
    const onUnavailableProductsUpdated = () => {
        subscribers.unavailableProductsUpdated.forEach(callback => callback());
    };
    const onUndo = () => {
        subscribers.undo.forEach(callback => callback());
    };
    const onUpdate = (productEntitiesWithPosition) => {
        subscribers.update.forEach(callback => callback(productEntitiesWithPosition));
    };
    const onWalls = (walls) => {
        subscribers.walls.forEach(callback => callback(walls));
    };
    return {
        onAllModelsLoaded,
        onConflict,
        onDeselected,
        onDuplicate,
        onEnableNightMode,
        onHelpLinesConflictsResolved,
        onHelpLinesShapeChange,
        onHelpLinesShapeResize,
        onHelpLinesShapeResizeFinished,
        onHelpLinesUpdated,
        onHistory,
        onInScene,
        onInvalidPlacement,
        onLoad,
        onLoadDesignId,
        onLoadLegacyShoppingItems,
        onLoadVpc,
        onLoadVpcFailure,
        onLoadVpcSuccess,
        onLoadWallShapeFromVpc,
        onModelLoaded,
        onMoveEnd,
        onMoving,
        onPlacementAttempt,
        onProppingAgeGroupUpdated,
        onRedo,
        onReset,
        onRoomSize,
        onSaveDesignId,
        onSaveVpcComplete,
        onSaveVpcStart,
        onSelected,
        onSolutionUpdateDone,
        onSolutionUpdateInProgress,
        onTooManyLightsAdded,
        onUnavailableProductsUpdated,
        onUndo,
        onUpdate,
        onWalls
    };
};
//# sourceMappingURL=getEventEmitters.js.map